/**
 * Коды операций. Те же числа объявлены в Tact как opcode сообщений, поэтому
 * payload, собранный здесь, читается контрактом без отдельной сериализации.
 */
export const Op = {
  createLaunch: 0x4c41554e,
  curveInit: 0x494e4954,
  buy: 0x42555900,
  sell: 0x53454c4c,
  graduate: 0x47524144,
  seedPool: 0x53454544,
  lockLp: 0x4c4f434b,
  harvestLp: 0x48415256,
  claim: 0x434c4149,
  claimPayout: 0x50415930,
  feeDeposit: 0x46454544,
  rebindChannel: 0x52454249,
  setConfig: 0x43464721,
  setProtocol: 0x5052544f,
  pauseLaunches: 0x50415553,
  retryPayout: 0x52545259,
  flushFees: 0x464c5348,
  dropAdmin: 0x44524f50,
} as const;

/** Коды операций стандарта жетонов (TEP-74 / TEP-89). */
export const JettonOp = {
  transfer: 0x0f8a7ea5,
  transferInternal: 0x178d4519,
  transferNotification: 0x7362d09c,
  excesses: 0xd53276db,
  burn: 0x595f07bc,
  burnNotification: 0x7bdd97de,
  provideWalletAddress: 0x2c76b973,
  takeWalletAddress: 0xd1735400,
  mint: 0x642b7d07,
} as const;

/** Маркер полезной нагрузки init-mint: кривая узнаёт свой первый mint. */
export const INIT_MINT_MARKER = 0x494e4954;

/** Вид адаптера DEX, который лежит в `dexKind` запуска. */
export const DexKind = {
  none: 0,
  stonfi: 1,
  dedust: 2,
} as const;

/** Коды операций STON.fi CPI v2 и pTON v2.1, которые собирает адаптер. */
export const StonOp = {
  provideLp: 0x37c096df,
  getterPoolData: 0x26df39fc,
  refundMe: 0x132b9a2c,
  tonTransfer: 0x01f3835d,
} as const;

/** Коды операций DeDust volatile v2. */
export const DedustOp = {
  createVault: 0x21cfe02b,
  createVolatilePool: 0x97d51f2f,
  depositLiquidityNative: 0xd55e4686,
  depositLiquidityJetton: 0x40e108d6,
  cancelDeposit: 0x166cedee,
} as const;

/** Вид депозита в `FeeVault`: сделка на кривой, доля градуации, harvest. */
export const FeeKind = {
  trade: 0,
  graduation: 1,
  harvest: 2,
} as const;
